<script setup>
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useTitle } from "vue-page-title";

const { t } = useI18n();

const { setTitle } = useTitle();
setTitle(t('privacy.title'));

const router = useRouter();
definePage({
  meta: {
    requiresAuth: false,
    layout: 'unauthenticated',
  },
});
</script>

<template>
  <v-container
    class="pa-4"
    max-width="1000"
  >
    <v-card class="pa-6">
      <v-btn
        icon
        @click="router.back()"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <h1 class="my-6">
        PRIVACYVERKLARING
      </h1>

      <section>
        <h2>INDUFAST B.V.</h2>
        <p>DAUMIERSTRAAT 16<br>5623 EV EINDHOVEN<br>NEDERLAND<br>INFO@INDUFAST.NL</p>
      </section>

      <section>
        <h2>1. ALGEMENE INFORMATIE</h2>
        <h3>A. PRIVACY</h3>
        <ol type="i">
          <li>Indufast B.V. neemt uw privacy serieus. Wij verwerken persoonsgegevens van u wanneer u gebruik maakt van onze website, van onze diensten of omdat u deze gegevens zelf aan ons verstrekt.</li>
          <li>In de zin van de Algemene Verordening Gegevensbescherming (AVG) is Indufast B.V. de zogenaamde verwerkingsverantwoordelijke.</li>
        </ol>
        <h3>B. SAMENVATTING</h3>
        <ol type="i">
          <li>
            Wij spannen ons in om de persoonsgegevens die u aan ons hebt verstrekt op een zorgvuldige manier te verwerken. Met deze privacyverklaring bieden wij u een transparant en helder overzicht van:
            <ol type="a">
              <li>Voor welk doel wij uw persoonsgegevens verwerken;</li>
              <li>Welke persoonsgegevens wij van u kunnen verwerken;</li>
              <li>Hoelang wij uw persoonsgegevens zullen bewaren;</li>
              <li>Van welke (sub)verwerkers wij gebruik maken bij de verwerkingen van uw persoonsgegevens;</li>
              <li>Welke rechten u heeft op de grond van de AVG met betrekking tot de verwerking door Indufast B.V. en,</li>
              <li>Wat de maatregelen zijn die wij nemen om uw persoonsgegevens te beschermen.</li>
            </ol>
          </li>
        </ol>
      </section>

      <section>
        <h2>2. PERSOONSGEGEVENS DIE WIJ VERWERKEN</h2>
        <h3>A. DE VOLGENDE GEGEVENS WORDEN VIA DE WEBSITE VERZAMELD:</h3>
        <ol type="i">
          <li>Naam</li>
          <li>Adresgegevens</li>
          <li>E-mail</li>
          <li>Telefoon</li>
          <li>Overige persoonsgegevens die u actief verstrekt bij het contact</li>
          <li>Locatiegegevens</li>
          <li>Gegevens over uw activiteiten op onze website</li>
          <li>IP-adres</li>
          <li>Internetbrowser en apparaat type</li>
        </ol>
      </section>

      <section>
        <h2>3. BIJZONDERE EN/OF GEVOELIGE PERSOONSGEGEVENS DIE WIJ VERWERKEN</h2>
        <h3>A. MINDERJARIGE</h3>
        <ol type="i">
          <li>Onze website en dienstverlening heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar, met als uitzondering schriftelijke toestemming van ouders of voogd. Indufast B.V. kan niet controleren of een bezoeker ouder dan 16 jaar is, daarom raden wij ouders aan betrokken te zijn bij de online activiteiten van hun kinderen. Zo kunnen we samen voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming.</li>
        </ol>
        <h3>B. NEEM CONTACT OP BIJ HET VERMOEDEN VAN EEN FOUT</h3>
        <ol type="i">
          <li>Als u ervan overtuigd bent dat wij zonder de hiervoor genoemde toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info@indufast.nl. Wij zullen deze informatie dan onmiddellijk verwijderen.</li>
        </ol>
      </section>

      <section>
        <h2>4. WAAROM EN HOELANG WE GEGEVENS NODIG HEBBEN</h2>
        <h3>A. INDUFAST B.V. VERWERKT UW PERSOONSGEGEVENS VOOR DE VOLGENDE DOELEINDEN:</h3>
        <ol type="i">
          <li>U te kunnen e-mailen als dit nodig is om onze dienstverlening uit te kunnen voeren;</li>
          <li>U desgevraagd informatie toe te sturen naar aanleiding van het contactformulier en tot slot;</li>
          <li>Uw gedrag op de website te analyseren om daarmee onze website te verbeteren en deze af te stemmen op uw voorkeuren.</li>
        </ol>
        <h3>B. BEWAARTERMIJNEN</h3>
        <ol type="i">
          <li>Indufast B.V. zal uw persoonsgegevens niet langer bewaren dan strikt noodzakelijk is om de doelen te realiseren waarvoor uw gegevens worden verzameld. Wenst u informatie over onze bewaartermijnen in uw specifieke geval neem dan contact op via: info@indufast.nl</li>
        </ol>
      </section>

      <section>
        <h2>5. VERWERKINGEN DOOR DERDEN</h2>
        <ol type="i">
          <li>
            Naast de eventueel door ons gebruikte cookies, zoals is opgenomen in onze cookieverklaring, delen wij de gegevens die we op deze website van u verzamelen met de volgende derde partijen:
            <ol type="a">
              <li>Google</li>
              <li>RB-Media</li>
            </ol>
          </li>
          <li>Met de bovenstaande verwerkers hebben wij goede afspraken gemaakt. Wij dwingen deze derde(n) ertoe om minimaal hetzelfde niveau van beveiliging van de persoonsgegevens te hanteren als dat wij als verwerkingsverantwoordelijke u bieden.</li>
        </ol>
      </section>

      <section>
        <h2>6. UW WEBSITEBEZOEK IN KAART</h2>
        <h3>A. COOKIES</h3>
        <ol type="i">
          <li>
            Indufast B.V. maakt gebruik van cookies. Er bestaan verschillende soorten:
            <ol type="a">
              <li>Functionele cookies: Dit zijn cookies met een puur technische functionaliteit. Deze zorgen ervoor dat de website naar behoren werkt; zo kunnen bijvoorbeeld uw voorkeursinstellingen onthouden worden. Ook kunnen wij hiermee onze website en onze dienstverlening via de website optimaliseren.</li>
              <li>Analytische cookies van derden: Deze cookies kunnen uw surfgedrag bijhouden. Deze cookies worden geplaatst wanneer er gebruikt wordt gemaakt van analytische dienstverleners, zoals bijvoorbeeld Google Analytics.</li>
              <li>Tracking cookies: Deze cookies worden door een externe partij geplaatst. Door het lezen van de cookies herkent de adverteerder u bij een bezoek aan een site waarbij hij eveneens is betrokken. Als u verder surft, kunnen gepersonaliseerde advertenties worden getoond. Deze cookies kunnen ook uw surfgedrag bijhouden waardoor een zeer specifiek profiel door deze partijen kan worden opgebouwd. Dit profiel kan zo gedetailleerd zijn dat er sprake is van een persoonsgegeven.</li>
            </ol>
          </li>
        </ol>
        <h3>B. WAT ALS U NIET VAN COOKIES HOUDT</h3>
        <ol type="i">
          <li>Uw cookie instellingen zijn bij uw eerste bezoek aan onze website door uzelf ingesteld. Alle niet functionele cookies zijn per categorie te weigeren. Plaatsing van cookies, anders dan functionele of anonieme, analytische cookies, vindt alleen plaats na een actieve handeling door u als bezoeker. U kunt uw instellingen op ieder moment wijzigen via onze website.</li>
        </ol>
      </section>

      <section>
        <h2>7. GEGEVENS INZIEN, AANPASSEN OF VERWIJDEREN</h2>
        <h3>A. UW RECHTEN</h3>
        <ol type="i">
          <li>
            U heeft het recht om:
            <ol type="a">
              <li>uw persoonsgegevens in te zien;</li>
              <li>een verzoek tot correctie van gegevens in te dienen;</li>
              <li>een verzoek te doen minder gegevens door ons te laten verwerken;</li>
              <li>verwijdering van uw gegevens aan te vragen;</li>
              <li>uw gegevens te laten overdragen aan iemand anders;</li>
              <li>een klacht in te dienen zoals verder is beschreven in artikel 8.</li>
            </ol>
          </li>
          <li>Mocht u vragen of opmerkingen over de gegevensverwerking van Indufast B.V. hebben, stuur dan een verzoek naar info@indufast.nl</li>
          <li>Indufast B.V. wil er zeker van zijn dat het verzoek tot inzage door u is gedaan. Daarom vragen wij u vriendelijk om, tezamen met uw verzoek tot inzage, correctie of verwijdering, een kopie van uw identiteitsbewijs mee te sturen. Ter bescherming van uw privacy verzoekt Indufast B.V. u om in deze kopie uw pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart te maken.</li>
          <li>Indufast B.V. zal zo snel mogelijk, maar in ieder geval binnen vier weken, op uw verzoek reageren.</li>
        </ol>
      </section>

      <section>
        <h2>8. KLACHTRECHT</h2>
        <h3>A. INTERNE BEHANDELING</h3>
        <ol type="i">
          <li>Wanneer u klachten heeft over de wijze van verwerking van (persoons)gegevens dan helpt Indufast B.V. u graag om deze in onderling overleg uit de wereld te helpen. Richt uw klacht voor behandeling in eerste instantie tot info@indufast.nl.</li>
        </ol>
        <h3>B. AUTORITEIT PERSOONSGEGEVENS</h3>
        <ol type="i">
          <li>
            Op grond van de Algemene Verordening Gegevensbescherming heeft u het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens over onze verwerkingen van uw persoonsgegevens. U kunt hiervoor contact opnemen met de Autoriteit Persoonsgegevens. Meer informatie over uw klachtrecht vindt u via: <a
              href="https://autoriteitpersoonsgegevens.nl/nl/zelf-doen/privacyrechten/klacht-over-gebruik-persoonsgegevens"
              target="_blank"
              rel="noopener"
            >https://autoriteitpersoonsgegevens.nl/nl/zelf-doen/privacyrechten/klacht-over-gebruik-persoonsgegevens</a>
          </li>
        </ol>
      </section>

      <section>
        <h2>9. BEVEILIGING VAN COMMUNICATIE DOOR SSL - ENCRYPTIE</h2>
        <h3>A. SSL</h3>
        <ol type="i">
          <li>Om u als websitebezoeker te beschermen gebruikt Indufast B.V. veilige coderingstechnologieën. Met SSL (Secure Socket Layer) worden uw persoonlijke gegevens versleuteld gebruikt op onze site (voor derden dus niet zichtbaar). Zo kunt u er zeker van zijn dat uw gegevens alleen voor u en onze server zichtbaar zullen zijn.</li>
          <li>Bij alle onderdelen van onze site waar uw gegevens gebruikt worden, zoals bij het invullen van het contactformulier, gebruiken wij SSL-encryptie. U kunt dit zelf controleren en herkennen. Wanneer u op een versleuteld gedeelte van onze site bent, ziet u een slotsymbool rechtsonder of linksboven in uw browser verschijnen. Daarnaast verandert ook de URL van http:// in https:// wat ook aangeeft dat de pagina beveiligd is.</li>
        </ol>
        <h3>B. WIJ NEMEN BEVEILIGING SERIEUS</h3>
        <ol type="i">
          <li>Indufast B.V. neemt de bescherming van uw gegevens erg serieus en neemt daarom passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u het idee heeft dat uw gegevens toch niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan direct contact met ons op via info@indufast.nl.</li>
        </ol>
      </section>

      <section>
        <h2>10. WIJZIGINGEN IN DEZE PRIVACYVERKLARING</h2>
        <h3>A. WIJZIGINGEN</h3>
        <ol type="i">
          <li>Aangezien Indufast B.V. haar eigen beleid steeds opnieuw zal evalueren en mogelijk nieuwe verwerkingsdoeleinden op onze website(s) kunnen worden toegevoegd, kunnen er wijzigingen optreden in deze privacyverklaring.</li>
        </ol>
      </section>

      <section>
        <h2>11. VRAGEN</h2>
        <h3>A. CONTACTPERSOON</h3>
        <ol type="i">
          <li>Indufast B.V. heeft Joost Hermans aangesteld als verantwoordelijke op het gebied van de AVG. Heeft u opmerkingen naar aanleiding van deze privacyverklaring of heeft u algemene vragen omtrent de AVG, dan kunt u contact opnemen via info@indufast.nl</li>
        </ol>
      </section>
    </v-card>
  </v-container>
</template>

<style scoped>
section {
  margin-bottom: 2rem;
}

section ol {
  padding-left: 2rem;
}

h2, h3 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
